import {InviteeParticipantRole, PlatformInfo} from 'types';

export type UserInfo = {
    firstName?: string;
    lastName?: string;
    id?: string;
    email?: string;
    phone?: string;
    topic?: string;
    controlOnlyInfo?: Record<string, string>;
} & Record<string, any>;

export type ClientMeta = {
    urlFrom: string;
}
export enum ClientDevice {
    Browser = 'browser',
    AndroidSDK = 'android-sdk',
    IosSDK = 'ios-sdk',
    Sip = 'sip',
    Phone = 'phone',
}

export type JoinClientSessionParams = {
    readonly inviteClientParams: {
        readonly code: number;
        readonly pin: number;
    }
    readonly data: {
        readonly clientInfo: PlatformInfo;
        readonly userInfo?: UserInfo;
        readonly meta?: any;
        readonly device: string;
    }
    readonly role?: InviteeParticipantRole;
};
